<div class="container-fluid">
  <div class="row p-0 justify-content-center">
    <div
      class="card col-11 col-md-5 col-lg-4 col-xl-3 m-1 p-0"
      style="width: auto"
      *ngFor="let proyecto of proyectos"
    >
      <div class="card-header d-flex justify-content-center">
        <img
          [src]="proyecto.img"
          [alt]="proyecto.name"
          class="card-img-top m-0 p-0"
          style="width: 90%"
        />
      </div>

      <div class="card-body">
        <h5 class="card-title">
          {{ proyecto.name }}
        </h5>
        <p class="card-text">
          {{ proyecto.description }}
        </p>
      </div>
      <div class="card-footer m-0 p-0">
        <div class="row col-12 m-0 p-0">
          <img
            class="col-auto m-0 mt-1 mb-1"
            style="width: 73px; height: auto"
            *ngFor="let tecnologia of proyecto.techlonogy"
            [src]="tecnologia.DES_IMG"
          />
        </div>
        <div class="mt-2 mb-2 row justify-content-center">
          <button
            class="btn btn-outline-primary m-1"
            *ngIf="proyecto.demolink"
            (click)="gotoUrl(proyecto.demolink)"
          >
            Ver proyecto
          </button>
          <button
            class="btn btn-outline-primary m-1"
            *ngIf="proyecto.githubrepo"
            (click)="gotoUrl(proyecto.githubrepo)"
          >
            Ver repo
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
